import jquery from 'jquery';

const FAVICON_SELECTOR = "head link[rel*='icon']";
const TITLE_SELECTOR = 'head title';

export const ORIGINAL_FAVICON_PATH = jquery(FAVICON_SELECTOR).attr('href');

export const ORIGINAL_PAGE_TITLE = jquery(TITLE_SELECTOR).text();

export const changePageFavicon = (path: string): unknown =>
  jquery(FAVICON_SELECTOR).attr('href', path);

export const restorePageFavicon = (): void => {
  if (ORIGINAL_FAVICON_PATH != null) {
    jquery(FAVICON_SELECTOR).attr('href', ORIGINAL_FAVICON_PATH);
  }
};

export const changePageTitle = (title: string): unknown =>
  jquery(TITLE_SELECTOR).text(title);

export const restorePageTitle = (): unknown =>
  jquery(TITLE_SELECTOR).text(ORIGINAL_PAGE_TITLE);
